/** @type {import('../help-index.js').HelpSidebarItem} */
export const LAB_REC_NEWS_ITEM = {
  id: 'news_sidebar',
  screenId: 'lab-rec-news',
  label: 'Novedades',
  description: 'Días trabajados y conceptos del período antes de liquidar.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Antes de liquidar recibos cargás cuánto trabajó cada empleado en el período y los conceptos adicionales (horas extra, vacaciones, etc.). El sueldo básico, antigüedad, SAC y descuentos automáticos los calcula el sistema al liquidar.',
      },
      {
        title: 'Paso 1 — Elegir liquidación',
        fields: [
          { label: 'Período', description: 'Período habilitado de salarios.' },
          { label: 'Nº liq.', description: 'Mismo número que usarás en Recibos (ej. 1 para liquidación mensual única).' },
        ],
      },
      {
        title: 'Paso 2 — Lista por empleado',
        bullets: [
          'Columnas: Empleado, CUIL, Básico (mes completo o cantidad de días/horas), Conceptos (códigos cargados).',
          'Tocá un empleado para ver o editar sus novedades de esa liquidación.',
          'Botón + para cargar novedades de un empleado nuevo en esta liquidación.',
        ],
      },
      {
        title: 'Paso 3 — Cargar novedades (manual)',
        intro: 'En el formulario de cada empleado:',
        fields: [
          {
            label: 'Básico (obligatorio)',
            description: 'Empleados mensuales: «Mes completo» o días trabajados si fue parte del mes. Diarios/horarios: cantidad de días u horas según el tipo de sueldo del empleado.',
          },
          {
            label: 'Conceptos adicionales',
            description: 'Solo conceptos con forma de cálculo «Cantidad × valor» (ej. horas extra). Indicá concepto, cantidad y valor unitario opcional.',
          },
        ],
        paragraphs: ['Tocá «Guardar todo» para reemplazar las novedades de ese empleado en la liquidación.'],
      },
      {
        title: 'Paso 4 — Importar Excel',
        bullets: [
          'Botón «Importar Excel» — archivo .xlsx o .xlsm.',
          'Columnas: CUIL, nro_liquidacion (opcional), concepto, cantidad, valor, mes_completo, observaciones.',
          'El concepto puede ser código interno o código LSD. Para el básico use concepto BASICO o deje mes_completo.',
          'Plantilla de referencia en el servidor: NOT-FOR-PROD/payroll_news_import_template.csv.',
        ],
      },
    ],
  },
}
